import { css } from "@emotion/react";
import React from "react";
import { useTheme } from "../theme";
export interface ListItemIconProps extends React.ComponentPropsWithoutRef<"div"> {
  children?: React.ReactNode;
}
export const ListItemIcon = (props: ListItemIconProps) => {
  const { palette } = useTheme();
  return (
    <div
      css={css`
        display: inline-flex;
        flex-shrink: 0;
        min-width: 4ex;
        font-size: 1.1em;
        color: ${palette.text.secondary};
        vertical-align: text-bottom;
      `}
      {...props}
    />
  );
};
